
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class InfoMultiV extends Vue {
    @Prop() section!: any;
    @Prop() index!: number;
    // selectedSubSection: any = null;

    // selectSection(subSection: any) {
    //     this.selectedSubSection = subSection;
    // }

    // resetSelection(event: Event) {
    //     event.preventDefault();
    //     this.selectedSubSection = null;
    // }
}
